import React from "react"

/**
 * SidebarLoading Component - Pure Tailwind Version
 * Matches CandidateProfileSidebar exactly with shimmer loading effect
 * No custom CSS required - uses only Tailwind utilities
 */
const SidebarLoading = () => {
  return (
    <>
      {/* Mobile Header Shimmer - Only visible on mobile */}
      <div className="md:hidden fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {/* Menu button shimmer */}
          <div className="w-10 h-10 bg-gray-200 rounded-lg animate-pulse"></div>
          
          <div className="flex items-center space-x-2">
            {/* Logo shimmer */}
            <div className="w-8 h-8 bg-gray-200 rounded-md animate-pulse"></div>
            {/* Brand name shimmer */}
            <div className="h-6 w-24 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>
      </div>

      {/* Sidebar Shimmer */}
      <div className="bg-white h-screen w-64 flex flex-col fixed top-0 left-0 z-50 border-r border-gray-100">
        {/* Header with logo shimmer */}
        <div className="p-6 flex items-center justify-between">
          <div className="flex items-center space-x-1">
            {/* Logo shimmer */}
            <div className="w-8 h-8 bg-gray-200 rounded-md animate-pulse"></div>
            {/* Brand name shimmer */}
            <div className="h-6 w-24 bg-gray-200 rounded animate-pulse"></div>
          </div>

          {/* Close button shimmer - Only visible on mobile */}
          <div className="md:hidden w-9 h-9 bg-gray-200 rounded-lg animate-pulse"></div>
        </div>

        {/* Navigation Content Shimmer */}
        <div className="flex-1 px-4 pb-4 overflow-y-auto">
          {/* Main Menu Items Shimmer */}
          <div className="mb-6">
            <nav className="space-y-1">
              {/* Profile */}
              <div className="w-full flex items-center px-4 py-3 rounded-md">
                <div className="w-5 h-5 bg-gray-200 rounded mr-3 flex-shrink-0 animate-pulse"></div>
                <div className="h-4 w-14 bg-gray-200 rounded animate-pulse"></div>
              </div>

              {/* Resume Analysis */}
              <div className="w-full flex items-center px-4 py-3 rounded-md">
                <div className="w-5 h-5 bg-gray-200 rounded mr-3 flex-shrink-0 animate-pulse"></div>
                <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
              </div>

              {/* Jobs Applied */}
              <div className="w-full flex items-center px-4 py-3 rounded-md">
                <div className="w-5 h-5 bg-gray-200 rounded mr-3 flex-shrink-0 animate-pulse"></div>
                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
              </div>

              {/* Inbox */}
              <div className="w-full flex items-center px-4 py-3 rounded-md">
                <div className="w-5 h-5 bg-gray-200 rounded mr-3 flex-shrink-0 animate-pulse"></div>
                <div className="h-4 w-12 bg-gray-200 rounded animate-pulse"></div>
              </div>

              {/* Activity */}
              <div className="w-full flex items-center px-4 py-3 rounded-md">
                <div className="w-5 h-5 bg-gray-200 rounded mr-3 flex-shrink-0 animate-pulse"></div>
                <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </nav>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-200 my-4"></div>

          {/* Bottom Controls Shimmer */}
          <div className="mb-4">
            <nav className="space-y-1">
              {/* Sign Out shimmer */}
              <div className="w-full flex items-center px-4 py-2.5 rounded-md">
                <div className="w-5 h-5 bg-gray-200 rounded mr-3 flex-shrink-0 animate-pulse"></div>
                <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
              </div>

              {/* Theme toggle shimmer */}
              <div className="w-full flex items-center px-4 py-2.5 rounded-md">
                <div className="w-5 h-5 bg-gray-200 rounded mr-3 flex-shrink-0 animate-pulse"></div>
                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </>
  )
}

export default SidebarLoading